import { Theme } from '@mui/material';
import { CSSProperties } from 'react';

export const eventsPageStyles = (theme: Theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
	},
	videoStyles: {
		width: '100%',
		height: '100%',
		objectFit: 'cover',
		objectPosition: 'top center',
		pointerEvents: 'none',
	} as CSSProperties,
	flexColumn: {
		display: 'flex',
		flexDirection: 'column',
	},
	itemsCenter: {
		alignItems: 'center',
	},
	contentCenter: {
		justifyContent: 'center',
	},
	flexRow: {
		display: 'flex',
		flexDirection: 'row',
	},
	heroScreenTitle: {
		textTransform: 'uppercase',
		fontFamily: 'Integral CF',
		color: 'white',
		fontSize: { xs: '24px', md: '30px', lg: '42px' },
	},
	getAppSection: {
		mb: { xs: '80px', md: '120px', lg: '160px' },
	},
	categoriesSection: {
		rowGap: { xs: '50px', md: '100px', lg: '140px' },
	},
	getNewsSection: {
		mt: '160px',
	},
});
